// // SuperAdminDashboard.jsx
// import { useState, useEffect } from "react";

// import {
//   Box,
//   Drawer,
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   CssBaseline,
//   Grid,
//   Card,
//   CardContent,
//   Avatar,
//   Stack,
//   useTheme,
//   useMediaQuery,
//   Button,
//   MenuItem,
//   Menu,
// } from "@mui/material";

// import {
//   Menu as MenuIcon,
//   Store as StoreIcon,
//   People as PeopleIcon,
//   LocalShipping as LocalShippingIcon,
//   Business as BusinessIcon,
//   PersonAdd as PersonAddIcon,
//   DeliveryDining as DeliveryDiningIcon,
//   Dashboard as DashboardIcon,
// } from "@mui/icons-material";

// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   BarChart,
//   Bar,
//   ResponsiveContainer,
//   Cell,
// } from "recharts";

// import axios from "axios";
// import Grocerylogo from "../../images/Grocerylogo.png";
// import "@fontsource/poppins"; // Defaults to weight 400

// import ShopForm from "../Shop/ShopForm";
// import EmployeeRegistertationForm from "../Accounts/EmployeeRegistrationForm";
// import DeliveryBoyForm from "../Accounts/DeliveryBoyRegistrationForm";
// import { Link, useNavigate } from "react-router-dom";
// import { Badge } from "react-bootstrap";
// import RelationManagerRegistrationForm from "./RelationManagerRegistrationForm";
// import RelationManagerList from "../Accounts/RelationManagerList";

// import PermissionPage from "../../PermissionPage";

// import ViewListIcon from '@mui/icons-material/ViewList';

// const drawerWidth = 240;

// const SuperAdminDashboard = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [activePage, setActivePage] = useState("dashboard");
//     const [popupOpen, setPopupOpen] = useState(false);
//   const [counts, setCounts] = useState({
//     shops: 0,
//     customers: 0,
//     orders: 0,
//     employee:0,
//     deliveryBoys:0,
//     RelationManager:0,
//     products: 0,
//     reports: 0,
//   });
//  const [anchorEl, setAnchorEl] = useState(null);
//   const open = Boolean(anchorEl);
//   const navigate = useNavigate();

//   useEffect(() => {
//     axios
//       .get("https://sakhisshop.com/api/dashboard/counts")
//       .then((res) => setCounts(res.data))
//       .catch((err) => console.error("Error fetching counts:", err));
//   }, []);

//   const handleDrawerToggle = () => {
//     setMobileOpen(!mobileOpen);
//   };

//   const handlePageChange = (page) => {
//   if (page === "ViewRMShop") {
//     setPopupOpen(true); // Open popup when this item clicked
//   } else {
//     setActivePage(page);
//   }

//   if (isMobile) setMobileOpen(false); // optional: close drawer on mobile
// };

// const handleMenuClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//   };

//   const handleLogout = () => {
//     // Clear auth tokens or session storage if needed
//     localStorage.clear(); // Or remove specific keys
//     handleMenuClose();
//     navigate("/MyAccountsSignIn"); // Redirect to login page
//   };
//  const drawer = (
//     <Box
//       sx={{
//         position: "static",
//         // height: "200px",
//         // bgcolor: "#f9f9f9",
//         py: 2,
//         px: 1,
//         fontFamily: "Poppins",
//       }}
//     >
//       <Toolbar sx={{ justifyContent: "center", mb: 2, py: 3 }}>
//         {/* {isMobile && (
//           // <Box component="img" src={Grocerylogo} alt="Logo" sx={{ height: 60 }} />
//         )} */}
//       </Toolbar>
//       <List sx={{ fontFamily: "Poppins", px: 2 }}>
//         {[
//           { key: "dashboard", text: "Dashboard", icon: <DashboardIcon /> },
//           { key: "relationmanager", text: "RM Registration", icon: <PersonAddIcon /> },
//           { key: "shop", text: "Shop Registration", icon: <BusinessIcon /> },
//           { key: "ViewRMShop", text: "ViewRMShops Lists", icon: <ViewListIcon /> },
//           { key: "ViewPermissions", text: "Role Access", icon: <ViewListIcon /> },
//         ].map((item) => (
//           <ListItem
//             key={item.key}
//             onClick={() => handlePageChange(item.key)}
//             sx={{
//               my: 1,
//               mx: 1,
//               borderRadius: 2,
//               boxShadow: activePage === item.key ? 4 : 1,
//               bgcolor: activePage === item.key ? "#c8e6c9" : "white",
//               "&:hover": {
//                 backgroundColor: "#c5f6fa",
//                 transform: "scale(1.02)",
//                 boxShadow: 4,
//               },
//               transition: "0.2s ease-in-out",
//               cursor: "pointer",
//             }}
//           >
//             <ListItemIcon sx={{ color: "#333", minWidth: 50 }}>
//               <Badge
//                 color="secondary"
//                 variant="dot"
//                 invisible={activePage !== item.key}
//               >
//                 {item.icon}
//               </Badge>
//             </ListItemIcon>
//             <ListItemText
//               primary={item.text}
//               primaryTypographyProps={{
//                 fontSize: "16px",
//                 fontWeight: activePage === item.key ? "bold" : 500,
//                 fontFamily: "Poppins",
//               }}
//             />
//           </ListItem>
//         ))}
//       </List>
//     </Box>
//   );

//   const renderDashboardCard = (title, count, IconComponent, bgColor) => (
//     <Grid item xs={12} sm={6} md={4}>
//       <Card
//         sx={{
//           backgroundColor: bgColor,
//           color: "#fff",
//           borderRadius: 3,
//           boxShadow: 8,
//           p: 4,
//           height: 170,
//          width: "100%",
//          maxWidth: 400,
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//           transition: "0.3s",
//           "&:hover": {
//             transform: "translateY(-5px)",
//             boxShadow: 12,
//           },
//         }}
//       >

//         <CardContent sx={{ p: 0 }}>
//           <Stack direction="row" alignItems="center" spacing={3}>
//             <Avatar sx={{ bgcolor: "white", color: bgColor, width: 60, height: 60 }}>
//               <IconComponent fontSize="large" />
//             </Avatar>
//             <Box>
//             <Typography
//   variant="subtitle2"
//   fontWeight={600}
//   textTransform="uppercase"
//   sx={{ fontFamily: "Poppins" }}
// >
//   {title}
// </Typography>
// <Typography
//   variant="h4"
//   fontWeight={700}
//   sx={{ fontFamily: "Poppins" }}
// >
//   {count}
// </Typography>
//             </Box>
//           </Stack>
//         </CardContent>
//       </Card>
//     </Grid>
//   );

//   const chartData = [
//   { name: "Shops", value: counts.shops || 0 },
//   { name: "Customers", value: counts.customers || 0 },
//   { name: "Orders", value: counts.orders || 0 },
//  { name: "employee", value: counts.employee || 0 },
//   { name: "DB", value: counts.DB || 0 },
//   { name: "RM", value: counts.RM || 0 },
// ];

//   const renderPageContent = () => {
//     switch (activePage) {
//       case "relationmanager":
//         return <RelationManagerRegistrationForm />;
//       case "shop":
//         return <ShopForm />;
//       case "delivery":
//         return <DeliveryBoyForm />;
//           case "ViewPermissions":
//       return <PermissionPage />;
//       default:
//         return (
//           <Box sx={{ px: 2, width: "100%" , fontFamily: "Poppins" }}>
//             <Grid container spacing={4}>
//               {renderDashboardCard("Registered Shops", counts.shops, StoreIcon, "#488A99")}
//               {renderDashboardCard("Customers", counts.customers, PeopleIcon, "#6AB187")}
//               {renderDashboardCard("Orders", counts.orders, LocalShippingIcon, "#A5D8DD")}
//                {renderDashboardCard("Total Employees", counts.employee, StoreIcon, "#488A99")}
//               {renderDashboardCard("Delivery Boys", counts.deliveryBoys, PeopleIcon, "#6AB187")}
//               {renderDashboardCard("Relationship Manager", counts.RelationManager, LocalShippingIcon, "#A5D8DD")}
//             </Grid>
//             {/* <Grid container spacing={4} sx={{ mt: 3 }}>
//               <Grid item xs={12} md={6}>
//                 <Card sx={{ p: 3, borderRadius: 3, boxShadow: 4, height: 400 }}>
//                 <Typography
//                   variant="h6"
//                   fontWeight={600}
//                   gutterBottom
//                   sx={{ fontFamily: "Poppins" }}
//                 >
//   Registered Entities Analysis
// </Typography>
//                   <ResponsiveContainer width="100%" height={300}>
//   <BarChart data={chartData}>
//     <CartesianGrid strokeDasharray="3 3" />
//     <XAxis dataKey="name" tick={{ fontFamily: "Poppins", fontSize: 12 }} />
//     <YAxis allowDecimals={false} tick={{ fontFamily: "Poppins", fontSize: 12 }} />
//     <Tooltip />
//     <Bar dataKey="value" barSize={45} radius={[6, 6, 0, 0]}>
//       {chartData.map((entry, index) => (
//         <Cell
//           key={Cell-${index}}
//           fill={
//             index === 0 ? "#488A99" :
//             index === 1 ? "#6AB187" :
//             index === 2 ? "#A5D8DD" : "#8884d8" // fallback
//           }
//         />
//       ))}
//     </Bar>
//   </BarChart>
// </ResponsiveContainer>

//                 </Card>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Card sx={{ p: 3, borderRadius: 3, boxShadow: 4, height: 400 }}>
//                 <Typography
//                     variant="h6"
//                     fontWeight={600}
//                     gutterBottom
//                     sx={{ fontFamily: "Poppins" }}
//                   >
//                     Entity Distribution Overview
//                   </Typography>
//                   <ResponsiveContainer width="100%" height={300}>
//                     <LineChart data={chartData}>
//                       <CartesianGrid strokeDasharray="3 3" />
//                       <XAxis dataKey="name" tick={{ fontFamily: "Poppins", fontSize: 12 }} />
// <YAxis allowDecimals={false} tick={{ fontFamily: "Poppins", fontSize: 12 }} />
//                       <Tooltip />
//                       <Line type="monotone" dataKey="value" stroke="#4caf50" strokeWidth={3} />
//                     </LineChart>
//                   </ResponsiveContainer>
//                 </Card>
//               </Grid>
//             </Grid> */}
//           </Box>
//         );
//     }
//   };

//   return (
//     <Box sx={{ display: "flex" }}>
//       <CssBaseline />
//      <AppBar
//   position="fixed"
//   sx={{
//     zIndex: (theme) => theme.zIndex.drawer + 2, // add this
//     bgcolor: "#1b5e20",
//   }}
// >

//       <Toolbar sx={{ justifyContent: "space-between" }}>
//         <IconButton
//           color="inherit"
//           edge="start"
//           onClick={handleDrawerToggle}
//           sx={{ display: { sm: "none" } }}
//         >
//           <MenuIcon />
//         </IconButton>

//         {/* Logo */}
//         <Link to="/">
//           <img src={Grocerylogo} alt="Logo" style={{ height: 60 }} />
//         </Link>
// <div>
//       {/* <Button variant="contained" color="primary" onClick={() => setPopupOpen(true)}>
//         View RMs Shops
//       </Button> */}

//       <RelationManagerList open={popupOpen} onClose={() => setPopupOpen(false)} />
//        {/* <PermissionPage open={permissionsPopupOpen} onClose={() => setPermissionsPopupOpen(false)} /> */}

//     </div>
//         {/* Admin Profile with Dropdown */}
//         <div>
//           <IconButton onClick={handleMenuClick} color="inherit">
//             <Avatar
//               alt="Admin"
//               // src="/admin-avatar.png" // Use a real profile pic if available
//               sx={{ width: 40, height: 40 }}
//             />
//           </IconButton>
//           <Menu
//             anchorEl={anchorEl}
//             open={open}
//             onClose={handleMenuClose}
//             anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//             transformOrigin={{ vertical: "top", horizontal: "right" }}
//           >
//             <MenuItem disabled>
//               <Typography variant="subtitle1">Admin</Typography>
//             </MenuItem>
//             <MenuItem onClick={handleLogout}>Logout</MenuItem>
//           </Menu>
//         </div>
//       </Toolbar>
//     </AppBar>
//        <Box component="nav" sx={{ width: { sm: drawerWidth }, flexShrink: 0 }}>
//         <Drawer
//           variant="temporary"
//           open={mobileOpen}
//           onClose={handleDrawerToggle}
//           ModalProps={{ keepMounted: true }}
//           sx={{
//             display: { xs: "block", sm: "none" },
//             "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
//           }}
//         >
//           {drawer}
//         </Drawer>
//         <Drawer
//           variant="permanent"
//           sx={{
//             display: { xs: "none", sm: "block" },
//             "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
//           }}
//           open
//         >
//           {drawer}
//         </Drawer>
//       </Box>
//      {/* <Box
//   component="main"
//   sx={{
//     flexGrow: 1,
//     p: 3,
//     width: { sm: calc(100% - ${drawerWidth}px) },
//     ml: { sm: ${drawerWidth}px }, // ✅ Shift content to right of fixed drawer
//     mt: "70px",                     // ✅ Align with AppBar height
//   }}
// >

//         {renderPageContent()}

//       </Box> */}
//       <Box
//   component="main"
//   sx={{
//     flexGrow: 1,
//     p: 3,
//     width: "100%",   // use full width
//     mt: "70px",      // leave space for AppBar
//   }}
// >
//   {renderPageContent()}
// </Box>

//     </Box>
//   );
// };

// export default SuperAdminDashboard;

//Nikita codes
import { useState, useEffect } from "react";

import {
  Box,
  Drawer,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Grid,
  Card,
  CardContent,
  Avatar,
  Stack,
  useTheme,
  useMediaQuery,
  Button,
  MenuItem,
  Menu,
} from "@mui/material";

import {
  Menu as MenuIcon,
  Store as StoreIcon,
  People as PeopleIcon,
  LocalShipping as LocalShippingIcon,
  Business as BusinessIcon,
  PersonAdd as PersonAddIcon,
  DeliveryDining as DeliveryDiningIcon,
  Dashboard as DashboardIcon,
} from "@mui/icons-material";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  BarChart,
  Bar,
  ResponsiveContainer,
  Cell,
} from "recharts";

import axios from "axios";
import Grocerylogo from "../../images/Grocerylogo.png";
import "@fontsource/poppins"; // Defaults to weight 400

import ShopForm from "../Shop/ShopForm";
import EmployeeRegistertationForm from "../Accounts/EmployeeRegistrationForm";
import DeliveryBoyForm from "../Accounts/DeliveryBoyRegistrationForm";
import { Link, useNavigate } from "react-router-dom";
import { Badge } from "react-bootstrap";
import RelationManagerRegistrationForm from "./RelationManagerRegistrationForm";
import RelationManagerList from "../Accounts/RelationManagerList";

import PermissionPage from "../../PermissionPage";

import ViewListIcon from "@mui/icons-material/ViewList";

const drawerWidth = 240;

const SuperAdminDashboard = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activePage, setActivePage] = useState("dashboard");
  const [popupOpen, setPopupOpen] = useState(false);
  const role = localStorage.getItem("role");
  const [myShopsCount, setMyShopsCount] = useState(0);

  const [counts, setCounts] = useState({
    shops: 0,
    customers: 0,
    orders: 0,
    employee: 0,
    deliveryBoys: 0,
    RelationManager: 0,
    products: 0,
    reports: 0,
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  // Guard against reaching this dashboard via browser back/forward after logout -
  // client-side routing re-renders this component on popstate without a full
  // reload, so without this check a cleared session would still show cached data.
  useEffect(() => {
    const isLoggedIn = () => {
      const currentRole = (localStorage.getItem("role") || "").toUpperCase();
      return currentRole === "SUPERADMIN" || currentRole === "RM";
    };

    if (!isLoggedIn()) {
      navigate("/MyAccountsSignIn", { replace: true });
      return;
    }

    // Re-check when a bfcache-restored page (e.g. after forward navigation) is shown.
    const handlePageShow = (event) => {
      if (event.persisted && !isLoggedIn()) {
        navigate("/MyAccountsSignIn", { replace: true });
      }
    };
    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, [navigate]);

  const refreshMyShopsCount = () => {
    const rmId = localStorage.getItem("rmId");
    if (rmId) {
      axios
        .get(`https://sakhisshop.com/api/shops/count/byRm/${rmId}`) // ✅ count API
        .then((res) => setMyShopsCount(res.data || 0))
        .catch((err) => {
          console.error("Error fetching RM shops count:", err);
          setMyShopsCount(0);
        });
    }
  };

  useEffect(() => {
    axios
      .get("https://sakhisshop.com/api/dashboard/counts")
      .then((res) => setCounts(res.data))
      .catch((err) => console.error("Error fetching counts:", err));
  }, []);
  useEffect(() => {
    if (role === "RM") refreshMyShopsCount();
  }, [role]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handlePageChange = (page) => {
    if (page === "ViewRMShop" || page === "ViewMyShops") {
      setActivePage(page);
      setPopupOpen(true);
    } else {
      setActivePage(page);
    }

    if (isMobile) setMobileOpen(false);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleLogout = () => {
    localStorage.clear();
    handleMenuClose();
    navigate("/MyAccountsSignIn");
  };
  const drawer = (
    <Box sx={{ py: 2, px: 1, fontFamily: "Poppins" }}>
      <Toolbar sx={{ justifyContent: "center", mb: 2, py: 3 }} />
      <List sx={{ fontFamily: "Poppins", px: 2 }}>
        {role === "RM"
          ? // 👇 Only RM menu
            [
              {
                key: "shop",
                text: "Shop Registration",
                icon: <BusinessIcon />,
              },
              {
                key: "ViewMyShops",
                text: "View My Shops",
                icon: <ViewListIcon />,
              },
            ].map((item) => (
              <ListItem
                key={item.key}
                onClick={() => handlePageChange(item.key)}
                sx={{
                  my: 1,
                  mx: 1,
                  borderRadius: 2,
                  boxShadow: activePage === item.key ? 4 : 1,
                  bgcolor: activePage === item.key ? "#c8e6c9" : "white",
                  "&:hover": {
                    backgroundColor: "#c5f6fa",
                    transform: "scale(1.02)",
                    boxShadow: 4,
                  },
                  transition: "0.2s ease-in-out",
                  cursor: "pointer",
                }}
              >
                <ListItemIcon sx={{ color: "#333", minWidth: 50 }}>
                  <Badge
                    color="secondary"
                    variant="dot"
                    invisible={activePage !== item.key}
                  >
                    {item.icon}
                  </Badge>
                </ListItemIcon>
                <ListItemText
                  primary={item.text}
                  primaryTypographyProps={{
                    fontSize: "16px",
                    fontWeight: activePage === item.key ? "bold" : 500,
                    fontFamily: "Poppins",
                  }}
                />
              </ListItem>
            ))
          : // 👇 SuperAdmin menu
            [
              { key: "dashboard", text: "Dashboard", icon: <DashboardIcon /> },
              {
                key: "relationmanager",
                text: "RM Registration",
                icon: <PersonAddIcon />,
              },
              {
                key: "shop",
                text: "Shop Registration",
                icon: <BusinessIcon />,
              },
              {
                key: "ViewRMShop",
                text: "ViewRMShops Lists",
                icon: <ViewListIcon />,
              },
              {
                key: "ViewPermissions",
                text: "Role Access",
                icon: <ViewListIcon />,
              },
            ].map((item) => (
              <ListItem
                key={item.key}
                onClick={() => handlePageChange(item.key)}
                sx={{
                  my: 1,
                  mx: 1,
                  borderRadius: 2,
                  boxShadow: activePage === item.key ? 4 : 1,
                  bgcolor: activePage === item.key ? "#c8e6c9" : "white",
                  "&:hover": {
                    backgroundColor: "#c5f6fa",
                    transform: "scale(1.02)",
                    boxShadow: 4,
                  },
                  transition: "0.2s ease-in-out",
                  cursor: "pointer",
                }}
              >
                <ListItemIcon sx={{ color: "#333", minWidth: 50 }}>
                  <Badge
                    color="secondary"
                    variant="dot"
                    invisible={activePage !== item.key}
                  >
                    {item.icon}
                  </Badge>
                </ListItemIcon>
                <ListItemText
                  primary={item.text}
                  primaryTypographyProps={{
                    fontSize: "16px",
                    fontWeight: activePage === item.key ? "bold" : 500,
                    fontFamily: "Poppins",
                  }}
                />
              </ListItem>
            ))}
      </List>
    </Box>
  );

  const renderDashboardCard = (title, count, IconComponent, onClick) => (
    <Card
      onClick={onClick}
      sx={{
        flex: 1,
        height: 150,
        borderRadius: 1,
        p: 2,
        cursor: "pointer",

        // 👇 Important design changes
        background: "#fafafa", // pure white nahi
        border: "1px solid #e5e7eb",
        boxShadow: "0 8px 20px rgba(0,0,0,0.06)",

        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",

        transition: "all 0.2s ease",
        "&:active": {
          transform: "scale(0.98)",
        },
      }}
    >
      <Typography
        sx={{
          fontSize: 14,
          color: "#6b7280",
          fontWeight: 500,
        }}
      >
        {title}
      </Typography>

      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography
          sx={{
            fontSize: 28,
            fontWeight: 700,
            color: "#111827",
          }}
        >
          {count}
        </Typography>

        <Avatar
          sx={{
            background: "#f3f4f6",
            width: 50,
            height: 50,
          }}
        >
          <IconComponent sx={{ color: "#4b5563" }} />
        </Avatar>
      </Box>
    </Card>
  );

  const chartData = [
    { name: "Shops", value: counts.shops || 0 },
    { name: "Customers", value: counts.customers || 0 },
    { name: "Orders", value: counts.orders || 0 },
    { name: "employee", value: counts.employee || 0 },
    { name: "DB", value: counts.DB || 0 },
    { name: "RM", value: counts.RM || 0 },
  ];

  const renderPageContent = () => {
    switch (activePage) {
      case "relationmanager":
        return <RelationManagerRegistrationForm />;
      case "shop":
        return (
          <ShopForm onShopAdded={role === "RM" ? refreshMyShopsCount : null} />
        );

      case "delivery":
        return <DeliveryBoyForm />;
      case "ViewPermissions":
        return <PermissionPage />;
      // case "ViewMyShops":
      //   if (role === "RM") {
      //     return <MyShopList open={true} onClose={() => setPopupOpen(false)} />;
      //   } else {
      //     return <RelationManagerList open={true} onClose={() => setPopupOpen(false)} />;
      //   }

      default:
        if (role === "RM") {
          return (
            <Box
              sx={{
                px: { xs: 1, sm: 2 },
                width: "100%",
                fontFamily: "Poppins",
              }}
            >
              <Grid container spacing={2}>
                {renderDashboardCard(
                  "View My Shops",
                  myShopsCount,
                  BusinessIcon,
                  "#4e6d70ff",
                  () => navigate("/my-shops"), // 👈 Navigate to separate page
                )}
              </Grid>
            </Box>
          );
        }

        // ✅ SuperAdmin sees all counts, NOT "View My Shops"
        return (
          <Box sx={{ px: 2, mt: 2 }}>
            {/* Row 1 */}
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              {renderDashboardCard("Registered Shops", counts.shops, StoreIcon)}
              {renderDashboardCard("Customers", counts.customers, PeopleIcon)}
            </Box>

            {/* Row 2 */}
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              {renderDashboardCard("Orders", counts.orders, LocalShippingIcon)}
              {renderDashboardCard(
                "Total Employees",
                counts.employee,
                StoreIcon,
              )}
            </Box>

            {/* Row 3 */}
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              {renderDashboardCard(
                "Delivery Boys",
                counts.deliveryBoys,
                PeopleIcon,
              )}
              {renderDashboardCard(
                "Relationship Manager",
                counts.RelationManager,
                LocalShippingIcon,
              )}
            </Box>
          </Box>
        );
    }
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 2,
          bgcolor: "#1b5e20",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <IconButton
            color="inherit"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          {/* Logo */}
          <Link to="/">
            <img src={Grocerylogo} alt="Logo" style={{ height: 60 }} />
          </Link>
          <div>
            {/* <Button variant="contained" color="primary" onClick={() => setPopupOpen(true)}>
        View RMs Shops
      </Button> */}

            {/* {role === "RM" ? ( */}
            {/* <MyShopList
    open={popupOpen && activePage === "ViewMyShops"}
    onClose={() => setPopupOpen(false)}
  />
) : (
  <RelationManagerList
    open={popupOpen && activePage === "ViewRMShop"}
    onClose={() => setPopupOpen(false)}
  />
)} */}
          </div>
          {/* Admin Profile with Dropdown */}
          <div>
            <IconButton onClick={handleMenuClick} color="inherit">
              <Avatar
                alt="Admin"
                // src="/admin-avatar.png" // Use a real profile pic if available
                sx={{ width: 40, height: 40 }}
              />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem disabled>
                <Typography variant="subtitle1">Admin</Typography>
              </MenuItem>
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      <Box component="nav" sx={{ width: { sm: drawerWidth }, flexShrink: 0 }}>
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      {/* <Box
  component="main"
  sx={{
    flexGrow: 1,
    p: 3,
    width: { sm: calc(100% - ${drawerWidth}px) },
    ml: { sm: ${drawerWidth}px }, // ✅ Shift content to right of fixed drawer
    mt: "70px",                     // ✅ Align with AppBar height
  }}
>
        
        {renderPageContent()}
        
      </Box> */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: "100%", // use full width
          mt: "70px", // leave space for AppBar
        }}
      >
        {renderPageContent()}
      </Box>
    </Box>
  );
};

export default SuperAdminDashboard;
